import { render, staticRenderFns } from "./DiskUsageSummary.vue?vue&type=template&id=6ebde9e6"
import script from "./DiskUsageSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiskUsageSummary.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports